import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button } from '@qrios/frontend-library';
import { HistoryOutlined } from '@mui/icons-material';

import errors from '../../../../../../constants/errors';
import { ExpiredReport, ReportMetadata } from '../../../interfaces';
import { humanizeDistanceBetweenDates } from '../../../../../../constants/helpers/dates';

import DetailItem from '../detailItem';
import DetailsFactory from './detailsFactory';
import { HandleOpenDeleteDialog, HandleOpenRegenerateDialog } from '../../interfaces';

interface Props {
  report: ExpiredReport;
  generationAllowed: boolean;
  handleOpenDeleteDialog: HandleOpenDeleteDialog;
  handleOpenRegenerateDialog: HandleOpenRegenerateDialog;
  handleCloseDetailsDialog: () => void;
  appliedFilters: (filters: ReportMetadata) => ReactNode;
}
const ExpiredDetails = ({
  report,
  generationAllowed,
  handleOpenDeleteDialog,
  handleCloseDetailsDialog,
  handleOpenRegenerateDialog,
  appliedFilters
}: Props) => {
  const theme = useTheme();

  return (
    <DetailsFactory
      action={{
        icon: { component: HistoryOutlined, color: theme.palette.grey['700'] },
        text: 'This report is expired.',
        content: (
          <>
            <Box width="100%" mt={2}>
              <Button
                fullWidth
                onClick={() => {
                  handleOpenDeleteDialog(report);
                  handleCloseDetailsDialog();
                }}
                text="Delete report"
                danger
                data-testid="button-delete-report"
              />
            </Box>
          </>
        )
      }}
      metaContent={<DetailItem label="Expired date" value={humanizeDistanceBetweenDates(report.expireDate)} />}
      filtersContent={<DetailItem label="Applied filters" value={appliedFilters(report.metadata)} />}
    />
  );
};

export default ExpiredDetails;
